export default __webpack_public_path__ + "static/media/VR.1c0407d0.svg";